export default {"src":"/_next/static/media/search-icon.59845390.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};